import React, { Fragment, useEffect, useState } from 'react';
import { Accordion, Button, Card, Col, Form, Row } from 'react-bootstrap';
import './styles.css';

function Faq() {
  return (
    <div>
      <Accordion className='mt-4' defaultActiveKey='0'>
        <Accordion.Item eventKey={'1'} className='accordion-border'>
          <Accordion.Header>1. What is SIP?</Accordion.Header>
          <Accordion.Body>
            The full form of SIP is Systematic Investment Plan. In this scheme,
            you can buy precious metals (gold, silver, platinum, and palladium)
            for a fixed amount at a fixed interval (weekly or monthly). It
            enables you to accumulate gold, silver, platinum, and palladium in
            smaller quantities through periodicity. Thus, the periodic
            installment is used on your selected date to buy precious metals at
            a closing price of 10 a.m. on the same day.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey={'2'} className='accordion-border'>
          <Accordion.Header>2. Can you choose multiple SIP?</Accordion.Header>
          <Accordion.Body>
            Yes, you can choose more than one SIP by adding individual SIP
            details for each.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey={'3'} className='accordion-border'>
          <Accordion.Header>
            3. What is the purity of the precious metals in offering to
            customers?
          </Accordion.Header>
          <Accordion.Body>
            eBullion sources precious metals from London Good Delivery Refiners
            only. The minimum purity requirements for metal vaults are as
            follows: Gold: 9999; platinum: 9995; silver: 9999; palladium: 9995.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey={'4'} className='accordion-border'>
          <Accordion.Header>
            4. What is minimum amount of investment for SIP?
          </Accordion.Header>
          <Accordion.Body>
            The SIP investment can be started with a minimum amount of Rs. 100
            per week or month. There is no limit on the maximum amount for SIP
            investment, and you can invest in multiples of Rs. 100.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey={'5'} className='accordion-border'>
          <Accordion.Header>
            5. Can the tenure of the SIP plan be extended?
          </Accordion.Header>
          <Accordion.Body>
            No, once a SIP plan has been successfully created, the tenure of the
            plan cannot be extended. You can, however, get a new SIP Plan with
            only one click when your current SIP expires.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey={'6'} className='accordion-border'>
          <Accordion.Header>
            6. Where can I find the invoice for each order?
          </Accordion.Header>
          <Accordion.Body>
            You can download the invoice from the Passbook section on the
            dashboard.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey={'7'} className='accordion-border'>
          <Accordion.Header>
            7. Is it necessary to create several E-Mandates in order to generate
            multiple SIPs?
          </Accordion.Header>
          <Accordion.Body>
            Yes, it is mandatory to create a separate E-Mandate for each new
            SIP.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

export default Faq;
